// lib
import React, { memo, useCallback } from "react";

// js-utils
import { isEmpty } from "@swiggy-private/js-utils";

// dls
import { InlineChip } from "@swiggy-private/dls-web-core/dist/components/Chips/InlineChip";

// defs
import { ITab } from "../types";

interface ChipProps {
    tab: ITab;
    selectedPill: string;
    handlePillClick: (name: string) => void;
}

const Chip = ({ tab, selectedPill, handlePillClick }: ChipProps) => {
    const isSelected = tab.name === selectedPill;

    const onChipClick = useCallback(() => {
        handlePillClick(tab.name);
    }, [handlePillClick, tab.name]);

    if (isEmpty(tab.name)) {
        return <></>;
    }
    return (
        <InlineChip
            label={tab.name}
            onClick={onChipClick}
            isSelected={isSelected}
            textColor={isSelected ? tab.selectedTextColor : tab.unselectedTextColor}
            selectedbgColor={tab.selectedBackgroundColor}
            unselectedbgColor={tab.unselectedBackgroundColor}
            unselectedborderColor={tab.unselectedBorderColor}
            selectedborderColor={tab.selectedBorderColor}
            showRightIcon={tab.showRightIcon}
        />
    );
};

export default memo(Chip);
